import React, { createContext, useContext, useState, useEffect } from "react";

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
    // Get language from localStorage or default to Armenian
    const [language, setLanguage] = useState(localStorage.getItem("language") || "am");

    // Update localStorage when language changes
    useEffect(() => {
        localStorage.setItem("language", language);
    }, [language]);

    // Function to change language
    const changeLanguage = (lang) => {
        if (["am", "ru", "en"].includes(lang)) {
            setLanguage(lang);
        }
    };

    return (
        <LanguageContext.Provider value={{ language, changeLanguage }}>
            {children}
        </LanguageContext.Provider>
    );
};

export const useLanguage = () => useContext(LanguageContext); 